import React from 'react';
import './DetailView.style.css';
import { Flex } from 'antd';
import { Content, HtmlContent, Title, Text } from 'components';

const DetailView = (props) => {
  /* ===== Route ===== */

  /* ===== Props ===== */
  const {
    screenSize,
    title = '',
    type = '공지',
    content = '',
    period = '',
    color = '#111111',
  } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */

  return (
    <Content maxWidth={'100%'} padding={0}>
      {/* SECTION: 제목 */}
      <Flex
        flex={1}
        justify="space-between"
        vertical={screenSize >= 768 ? false : true}
        gap={4}
        style={{
          padding: '20px 0px',
          borderBottom: '1px solid rgb(211, 211, 211)',
        }}
      >
        <Flex align="baseline" gap={8}>
          <Flex
            style={{
              border: `1px solid ${color}`,
              padding: '4px 8px',
            }}
          >
            <p style={{ wordBreak: 'keep-all', color: color }}>{type}</p>
          </Flex>

          <Title
            style={{
              fontSize: 16,
              lineHeight: '150%',
            }}
          >
            {title}
          </Title>
        </Flex>

        <Flex vertical={screenSize >= 768 ? true : false} gap={4}>
          {period.map((item, index) => (
            <Text key={`${item}-${index}`} size={14} color={'#000000E0'}>
              {index ? ' ~ ' : ''}
              {item}
            </Text>
          ))}
        </Flex>
      </Flex>
      {/* !SECTION: 제목 */}
      {/* SECTION: 내용 */}
      <Flex flex={1} style={{ padding: '20px 0px' }}>
        <HtmlContent content={content} style={{ width: '100%', padding: 0 }} />
      </Flex>
      {/* !SECTION: 내용 */}
    </Content>
  );
};

export default DetailView;
